// web-ui Divider가 내부적으로 createContext를 사용해 서버 컴포넌트에서 직접 렌더할 수 없어
// 클라이언트 경계로 래핑한다. 이 컴포넌트를 import하면 클라이언트 경계를 넘는다.
'use client'

import { Divider } from '@macarongfactory/web-ui'

const PlaceSectionDivider = () => (
  <Divider.Horizontal
    strokeWidth='stroke-width-x10'
    color='background-surface-basement'
  />
)

export default PlaceSectionDivider
